import { root, id } from './encoder-profiles';

export const encoderProfiles = {
  ...root,
  id,
};
